export default {
  exams: [],
  mocktest: {},
  attempt: {},
  activeMocktests: [],
  mocktests: [],
  selectedTestLanguage: "hi",
  attemptedMocktests: [],
};
